<app-loader [isLoading]="isLoading"></app-loader>
@if(isUuid){
<router-outlet></router-outlet>
}@else {

<div class="header">
    <app-title [title]="title" [subtitle]="subtitle"></app-title>
    @if (myroles.can_write) {
    <div class="top">
        <div class="boton">
            <button class="b1" mat-button (click)="goToNewCulture()">Añadir cultura empresarial</button>
        </div>
    </div>
    }
</div>

<div class="content">

    <!-- <div class="filter">
        <div class="filter-buttons">
            @for (filter of filters; track filter.value){
            <button [class.active]="selectedFilter === filter.value" (click)="selectFilter(filter.value)">
                {{ filter.label }}
            </button>
            }
        </div>
        <div class="paginator-container">
            <mat-paginator [pageSizeOptions]="[25, 50, 100]" aria-label="Select page of the relation table"
                class="paginator-field">
            </mat-paginator>
        </div>
    </div> -->
    <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)"
        class="mat-elevation-z8 table">

        <!-- Columna de Título -->
        <ng-container matColumnDef="title">
            <th mat-header-cell *matHeaderCellDef>
                TÍTULO
            </th>
            <td mat-cell *matCellDef="let element">
                <span style="font-size: 16px;">{{element.name | mailTitle}}</span>
            </td>
        </ng-container>

        <!-- Columna de Autor -->
        <ng-container matColumnDef="author">
            <th mat-header-cell *matHeaderCellDef>
                AUTOR
            </th>
            <td mat-cell *matCellDef="let element">
                <span style="font-size: 16px;">{{element.author_name | qeqPipe}}</span>

            </td>
        </ng-container>

        <!-- Columna de Autor -->
        <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>
                ID
            </th>
            <td mat-cell *matCellDef="let element">
                <span style="font-size: 16px;">{{element.author_name}}</span>
            </td>
        </ng-container>

        <!-- Columna de Pestañas -->
        <ng-container matColumnDef="tabs">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                PESTAÑAS
            </th>
            <td mat-cell *matCellDef="let element">
                <span class="utility-button" style="font-size: 16px;">{{element.tab_count}}</span>
            </td>
        </ng-container>

        <!-- Columna de Publicación -->
        <ng-container matColumnDef="published-date">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                PUBLICACIÓN
            </th>
            <td mat-cell *matCellDef="let element">
                <button mat-flat-button id="button">
                    <span style="font-size: 16px;">{{element.created_when | customPipe}}</span>
                </button>
            </td>
        </ng-container>


        <!-- Columna de Acciones -->
        <ng-container matColumnDef="acciones">
            <th mat-header-cell *matHeaderCellDef>
            </th>
            <td mat-cell *matCellDef="let element">
                <!-- <button mat-icon-button class="acciones"><mat-icon style="color: #2D3872;">info_outline</mat-icon></button> -->
                @if (myroles.can_write) {
                <button mat-icon-button class="acciones" (click)="goToCulture(element)"><mat-icon
                        svgIcon="edit"></mat-icon></button>
                }
                @if (myroles.can_delete) {
                <button mat-icon-button class="acciones" (click)="deleteSelected(element.id, element.title)"><mat-icon
                        svgIcon="delete"></mat-icon></button>
                }
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
        </tr>
    </table>
</div>
}